export default [
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'cnova' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'cnova' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'colombo' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'leroy' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'mercadoLivre' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'mercadoLivre' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'netshoes' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'zoom' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'netshoes' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'netshoes' },
    active: true,
    type: 'brand',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'netshoes' },
    active: true,
    type: 'size',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'gfg' },
    active: true,
    type: 'brand',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'gfg' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'shein' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'sicredi' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'tool', identifier: 'api' },
    to: { type: 'marketplace', identifier: 'sicredi' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'maisCorreios' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'tool', identifier: 'api' },
    to: { type: 'marketplace', identifier: 'maisCorreios' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'gfg' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'amazon' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'amazon' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'amazon' },
    active: true,
    type: 'size',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'shopee' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'shopee' },
    active: true,
    type: 'size',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'shopee' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'sicredi' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'tool', identifier: 'api' },
    to: { type: 'marketplace', identifier: 'sicredi' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'ecommerce', identifier: 'moovin' },
    to: { type: 'marketplace', identifier: 'maisCorreios' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'tool', identifier: 'api' },
    to: { type: 'marketplace', identifier: 'maisCorreios' },
    active: true,
    type: 'color',
    items: []
  },
  {
    from: { type: 'tool', identifier: 'api' },
    to: { type: 'marketplace', identifier: 'leroy' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'tool', identifier: 'api' },
    to: { type: 'marketplace', identifier: 'cnova' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'tool', identifier: 'api' },
    to: { type: 'marketplace', identifier: 'colombo' },
    active: true,
    type: 'categorization',
    items: []
  },
  {
    from: { type: 'tool', identifier: 'api' },
    to: { type: 'marketplace', identifier: 'zoom' },
    active: true,
    type: 'categorization',
    items: []
  }
]



// WEBPACK FOOTER //
// ./src/storage/presets.js